import { render, staticRenderFns } from "./CopyrightDisputePolicy.vue?vue&type=template&id=6202980d&lang=pug"
var script = {}
import style0 from "./CopyrightDisputePolicy.vue?vue&type=style&index=0&id=6202980d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports